/**
 * Friendly, customer-safe error messages for the provider-agnostic bills layer
 * (/v3/bills). Provider-neutral — the active upstream vendor is a backend detail.
 */
export const getFriendlyBillsErrorMessage = (
  error: unknown,
  service: "data" | "airtime" | "cable-tv" | "electricity"
) => {
  const labels: Record<typeof service, string> = {
    data: "Data purchase",
    airtime: "Airtime purchase",
    "cable-tv": "Cable TV subscription",
    electricity: "Electricity purchase",
  };
  const fallback = `${labels[service]} could not be completed right now. Please try again later.`;

  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
      ? error
      : "";

  if (!message) {
    return fallback;
  }

  const lowerMessage = message.toLowerCase();

  if (
    lowerMessage.includes("manual review required") ||
    lowerMessage.includes("refund pending") ||
    lowerMessage.includes("temporarily unreachable")
  ) {
    return `${labels[service]} could not be completed right now. If your wallet was debited, our team will review and reverse it.`;
  }

  if (
    lowerMessage.includes("wallet refund processed") ||
    lowerMessage.includes("wallet debit reversed")
  ) {
    return `${labels[service]} could not be completed right now. If your wallet was debited, it has been reversed. Please try again later.`;
  }

  if (lowerMessage.includes("insufficient")) {
    return "Your wallet balance is not enough for this purchase.";
  }

  if (lowerMessage.includes("duplicate transaction")) {
    return "This looks like a duplicate transaction. Please wait a few minutes before trying again.";
  }

  if (lowerMessage.includes("pin")) {
    return message;
  }

  if (message.length > 180 || lowerMessage.includes("exception")) {
    return fallback;
  }

  return message;
};
